import { themeColors } from "@/utils/themeColors";
import { isDarkColor } from "@knowt/syncing/utils/genericUtils";

export const getProfileDynamicTextColor = ({ userProfile }) => {
    if (!userProfile.profileColor) {
        return themeColors.neutralBlack;
    } else if (isDarkColor(userProfile.profileColor)) {
        return themeColors.pureWhite;
    }
    return themeColors.pureBlack;
};
